import classNames from "classnames";
import styles from "./index.module.scss";

const MediaPostModalFooter = ({ title, description }) => (
  <div className={classNames("d-flex flex-column ", styles.container)}>
    <div
      className={classNames(
        "px-xl-4 mt-2 mt-xl-3 w-100",
        styles.titleContainer,
      )}
    >
      <div className="text-primary mb-1 mb-xl-2 text-body-1 subtitle-2-xl text-break text-emoji-semibold">
        {title}
      </div>
      <div
        className={classNames(
          "text-primary mb-0 text-body-2 text-body-1-xl text-break text-formatted text-emoji-regular",
          !description && "d-none",
        )}
      >
        {description}
      </div>
    </div>
  </div>
);

export default MediaPostModalFooter;
